import {RouteConfig} from '@deviceinsight/ng-ui-scale-lib/api';
import AssetGroupDataProcessingDefinition from '../../../../../modules/dataprocessingdefinitions/AssetGroupDataProcessingDefinition';
import {AUTHORITY_READ_KPI_DATA_PROCESSING_DEFINITION} from '../../../../../modules/common/consts';

export default {
	relativePath: 'edit/:dataProcessingDefinitionId',
	label: {
		id: 'assets.detail.dataProcessingDefinition.edit.title',
		defaultValue: 'Edit Data Processing Definition'
	},
	component: AssetGroupDataProcessingDefinition,
	requiredAuthorities: [AUTHORITY_READ_KPI_DATA_PROCESSING_DEFINITION]
} satisfies RouteConfig;
